import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Divider from '@mui/material/Divider';

import type { ISnippet } from 'src/services/api';
import { Flex, FlexColumn } from 'src/components/flex';
import SnippetsModalList from 'src/pages/landlord/leads/messages/components/snippets-modal/components/SnippetsModalList';
import SnippetsSearch from 'src/pages/landlord/leads/messages/components/snippets-modal/components/SnippetsSearch';

interface Props {
    open: boolean;
    onClose: React.Dispatch<React.SetStateAction<boolean>>;
    snippets: ISnippet[];
    setIsAddingSnippet: React.Dispatch<React.SetStateAction<boolean>>;
    setSnippetsModalOpen: (snippetsModalOpen: boolean) => void;
}

export default function SnippetsModal ({
    open,
    onClose,
    snippets,
    setIsAddingSnippet,
    setSnippetsModalOpen,
}: Props) {
    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            PaperProps={{
                sx: {
                    width: '100%',
                    height: '450px',
                }
            }}
        >
            <DialogTitle>
                <Flex justifyContent="space-between" alignItems="center" mb={2}>
                    Snippets
                    <IconButton onClick={() => onClose(false)}>
                        <CloseIcon />
                    </IconButton>
                </Flex>

                <Divider />
            </DialogTitle>
            <DialogContent>
                <FlexColumn>
                    <SnippetsSearch />
                    <SnippetsModalList
                        snippets={snippets}
                        setSnippetsModalOpen={setSnippetsModalOpen}
                    />
                </FlexColumn>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setIsAddingSnippet(true)}
                >
                    Add Snippet
                </Button>
            </DialogActions>
        </Dialog>
    );
}